// Archivage du PDF d'une facture sans l'ouvrir — écrans OperationView et FirewoodInvoiceView.
//
// La page STOCK → FSC doit livrer le PDF de TOUTES les factures FSC d'une période (Chady,
// 21/10/2026 : « il faut pas qu'il en manque »). Le PDF d'une facture n'est fabriqué que dans
// le navigateur (jsPDF) : la page FSC charge donc l'écran de la facture dans un cadre invisible,
// avec `?archivePdf=1`. L'écran génère alors le PDF exactement comme le bouton « Invoice PDF »
// (même mise en page, même empreinte des montants), le téléverse sans l'ouvrir, puis prévient la
// page FSC par postMessage (même origine uniquement).
//
// Contrat avec l'écran hôte : GenerateDocumentEN(false) renvoie une promesse qui vaut true quand
// le PDF a bien été téléversé, autre chose sinon (garde-fou adresse, langue, totaux…).
export const ARCHIVE_MESSAGE = 'xylo-invoice-pdf-archived'

export default {
  computed: {
    archivePdfMode () {
      return this.$route.query.archivePdf === '1' || this.$route.query.archivePdf === 1
    }
  },
  methods: {
    // Le devis porte le FSC (« FSC Required? ») : le PDF ne doit jamais être généré avant
    // qu'il soit chargé, sinon la mention de certification disparaît en silence.
    waitForQuotation () {
      return this.quotationReady ? this.quotationReady.catch(() => {}) : Promise.resolve()
    },
    async runArchivePdf () {
      const idoperation = Number(this.$route.params.userId)
      let ok = false
      let error = null
      try {
        // true = archivé ; false = PDF fait mais refusé par le serveur ; sinon un garde-fou
        // (adresse, langue, totaux) a arrêté la génération avant.
        const result = await this.GenerateDocumentEN(false)
        ok = result === true
        if (result === false) {
          error = `The PDF was made but the server could not archive it${this.lastUploadError ? `: ${this.lastUploadError}` : '.'}`
        } else if (!ok) {
          error = 'The PDF was not generated: open the invoice and click “Invoice PDF” to see why.'
        }
      } catch (e) {
        error = (e && e.message) || 'The PDF could not be generated.'
      }
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: ARCHIVE_MESSAGE, idoperation, ok, error }, window.location.origin)
      }
    }
  }
}
